<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>{{ $route.meta.title }}</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <!-- main row for all icons  -->
                <div class="col-lg-12">
                    <div class="card card-danger">
                        <div class="card-header">Manage Add On Services</div>
                        <div class="card-body overflow-auto">
                            <table
                                class="table table-striped table-bordered table-hover"
                            >
                                <thead>
                                    <tr>
                                        <th>Slab Name</th>
                                        <th>Limit</th>
                                        <th>Validity</th>
                                        <th>Change</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="j in services" :key="j.id">
                                        <td>{{ j.slab_name }}</td>
                                        <td>{{ j.buyback_limit }}</td>
                                        <td>{{ j.validity }}</td>
                                        <td>
                                            <button
                                                class="btn btn-success fa fa-play"
                                                v-if="j.validity == 'Inactive'"
                                                @click="
                                                    changeService(
                                                        j.id,
                                                        'Active'
                                                    )
                                                "
                                            ></button>
                                            <button
                                                class="btn btn-danger fa fa-square"
                                                v-else-if="
                                                    j.validity == 'Active'
                                                "
                                                @click="
                                                    changeService(
                                                        j.id,
                                                        'Inactive'
                                                    )
                                                "
                                            ></button>
                                            <button
                                                class="btn btn-danger fa fa-trash"
                                                @click="
                                                    changeService(
                                                        j.id,
                                                        'Deleted'
                                                    )
                                                "
                                            ></button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="card-footer">
                            <div class="col-sm-12">
                                <div class="row">
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.buyback_name
                                                ? 'has-error'
                                                : '',
                                        ]"
                                    >
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="form.buyback_name"
                                            placeholder="Enter new name"
                                        />
                                        <span
                                            v-if="errors.buyback_name"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid name.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.buyback_limit
                                                ? 'has-error'
                                                : '',
                                        ]"
                                    >
                                        <input
                                            type="number"
                                            class="form-control"
                                            v-model="form.buyback_limit"
                                            placeholder="Enter new buyback limit"
                                            min="1"
                                        />
                                        <span
                                            v-if="errors.buyback_limit"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid buyback
                                            limit.</span
                                        >
                                    </div>
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            @click="addService"
                                        >
                                            <i class="fa fa-plus"></i> Add
                                            Buyback
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        this.getBuybackSlabs();
    },

    data() {
        return {
            form: new Form({
                buyback_name: "",
                buyback_limit: "",
            }),

            services: [],
            errors: [],
        };
    },

    methods: {
        addService() {
            this.form
                .post("/api/addBuyback")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Item Added!",
                        });
                        this.getServices();
                    }
                })
                .catch((errors) => {
                    this.errors = errors.response.data.errors;
                });
        },

        changeService(id, status) {
            axios
                .post("/api/changeBuybackStatus", { id: id, status: status })
                .then((response) => {
                    if (response.data == 200) {
                        this.getServices();
                    }
                });
        },

        getBuybackSlabs() {
            axios.post("/api/getBuybackSlabs").then((response) => {
                this.services = response.data;
            });
        },
    },
};
</script>
